// src/pages/B2B/event-reports/utils/formatTzWindow.ts

export function formatTzWindow(
  fromLocal: string,
  toLocal: string,
  timezone: string,
): string {
  if (!fromLocal || !toLocal) return '';

  const tzShort = timezone.split('/').pop()?.replace(/_/g, ' ') ?? timezone;
  const fmt = (s: string): string => {
    const d = new Date(s);
    // A `datetime-local` string is already wall-clock time in the report's
    // timezone. An ISO instant (saved reports) has to be shifted into it, or
    // it would render in the viewer's own timezone under the report's label.
    const timeZone = /(Z|[+-]\d\d:\d\d)$/.test(s) ? timezone : undefined;
    const date = d.toLocaleDateString(undefined, {
      timeZone,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
    const time = d.toLocaleTimeString(undefined, {
      timeZone,
      hour: 'numeric',
      minute: '2-digit',
    });
    return `${date}, ${time}`;
  };

  return `${fmt(fromLocal)} – ${fmt(toLocal)} · ${tzShort}`;
}
